import request from '@/utils/request'

/**
 * 交易记录列表
 * @param {*} form 
 */
export function getFundRecord(form) {
	return request.post('/cust/getFundRecord', form);
}